// extracted by mini-css-extract-plugin
export default {"mCard":"Dy-z","image":"Ey-z","imageNoBackground":"Fy-z","imageHasCategory":"Gy-z","fullWidth":"Hy-z"};